import React from 'react';
import {Box, Stack, Tooltip} from '@mui/material';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {getValidationStepsForProductType} from '../../../../apps/reviewer/pages/product/constants/validationStepSelectors';

/**
 * Get the appropriate icon for a validation step
 * @param {Object} entry - Validation entry
 * @returns {JSX.Element} - Icon component
 */
const getValidationIcon = (entry) => {
    if (!entry) {
        return <HourglassBottomIcon color="disabled"/>;
    }

    if (entry.passed === true) {
        return <CheckCircleOutlineIcon color="success"/>;
    }

    if (entry.passed === false) {
        return <ErrorOutlineIcon color="error"/>;
    }

    return <HourglassBottomIcon color="disabled"/>;
};

/**
 * Displays validation status icons for a report
 * @param {Object} validation - Validation data from report
 * @param {number} flex - Flex value for the cell
 * @param {string} productTypeValue - Product type value
 */
const ValidationStatusCell = ({validation, flex, productTypeValue = null}) => {
    const safeValidation = validation ?? {};
    const validationSteps = getValidationStepsForProductType(productTypeValue);

    return (
        <Stack direction="row" spacing={0.5} alignItems="center" flex={flex} sx={{flexShrink: 0}}>
            {validationSteps.map((step, idx) => {
                const entry = safeValidation[idx];
                const Icon = getValidationIcon(entry);

                return (
                    <Tooltip key={step.key} title={step.label} arrow placement="top">
                        <Box component="span" sx={{display: 'inline-flex', alignItems: 'center', lineHeight: 0}}>
                            {Icon}
                        </Box>
                    </Tooltip>
                );
            })}
        </Stack>
    );
};

export default ValidationStatusCell;
